import { Tooltip as BsTooltip } from "bootstrap";
import React, { useEffect, useRef } from "react";

const validPlacements = ["auto", "top", "bottom", "left", "right"];

export const Tooltip = (p) => {
  const childRef = useRef(undefined);

  useEffect(() => {
    const placement = validPlacements.includes(p.placement)
      ? p.placement
      : "top";

    const t = new BsTooltip(childRef.current, {
      title: p.text,
      placement,
      trigger: "hover",
    });
    return () => t.dispose();
  }, [p.text, p.placement]);

  return React.cloneElement(p.children, { ref: childRef });
};
